import { useCurrentLocaleSelector as getCurrentLocaleSelector } from './localisation';
import axios from "axios";
import { getBearerToken } from "../auth";
import { refreshUserAccessToken } from './kintopiaApi';
import { getCurrentUserEmail, getCurrentUserKinshipId } from './apis';
import { FIREBASE_BASE_URL } from '../constants';

function isFirebaseEndpoint(url) {
  if (!url) return false;
  return url.startsWith(FIREBASE_BASE_URL);
}



const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
    "X-Kinship-Source": "THE_WILDEST_ADMIN",
    'Accept-Language': getCurrentLocaleSelector(),

  },
  mode: "no-cors",
  crossdomain: true,
  // baseURL: API_URL,
  baseURL: process.env.REACT_APP_KINTOPIA_API_BASE_PATH,
});

axiosInstance.interceptors.request.use(async (config) => {
  if (config.url === 'auth/v2-sign-in') {
    return config;
  }
  const token = await getBearerToken();
  config.headers.common["Authorization"] = `Bearer ${token}`;

  if (isFirebaseEndpoint(config.url)) {
    config.headers["X-KI-Requester-Email"] = getCurrentUserEmail();
    config.headers["X-KI-Requester-Id"] = getCurrentUserKinshipId();
  }
  return config;
});

axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    const status = error?.response?.status;
    const data = error?.response?.data;

    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    // Entitlement denied detection
    const message = typeof data?.message === "string" ? data.message : "";
    const isEntitlementDenied =
      status === 403 &&
      message.toLowerCase().includes("entitlement denied for resource");

    if (isEntitlementDenied) {
      return Promise.reject({
        ...error,
        __kind: "ENTITLEMENT_DENIED",
        __message: message || "You don’t have permission to access this feature.",
      });
    }

    if (error.response.data.status === 403) {
      await refreshUserAccessToken();
    }
    return Promise.reject(error);
  }
);

// consider renaming to authedAxiosInstace or something later on.
export default axiosInstance;
